module.exports = __webpack_public_path__ + "img/TGBATRIS.16c500b6.png";